<mat-card class="cardT ponto-eletronico-titulo">
  <span>Ponto Eletrônico</span>

  <span class="ponto-eletronico-acoes">
    <button
      mat-icon-button
      type="button"
      matTooltip="Logs do Ponto"
      [class.ponto-eletronico-acao--ativa]="modoExibicao === 'calendario'"
      [disabled]="modoExibicao === 'calendario'"
      (click)="exibirCalendario()">
      <mat-icon>calendar_today</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Logs em Lista"
      [class.ponto-eletronico-acao--ativa]="modoExibicao === 'historico'"
      [disabled]="modoExibicao === 'historico'"
      (click)="exibirHistorico()">
      <mat-icon>list_alt</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Agendamentos do Ponto"
      [class.ponto-eletronico-acao--ativa]="modoExibicao === 'agendamentos'"
      [disabled]="modoExibicao === 'agendamentos'"
      (click)="exibirAgendamentos()">
      <mat-icon>alarm</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Feriados do Ponto"
      [class.ponto-eletronico-acao--ativa]="modoExibicao === 'feriados'"
      [disabled]="modoExibicao === 'feriados'"
      (click)="exibirFeriados()">
      <mat-icon>event_busy</mat-icon>
    </button>
  </span>
</mat-card>

<div class="actions" *ngIf="false">
  <button type="button" color="primary" class="btn" mat-raised-button [disabled]="registrando" (click)="registrarPontoReal()">
    <mat-icon>how_to_reg</mat-icon>
    Registrar ponto
  </button>

  <button type="button" color="primary" class="btn" mat-raised-button [disabled]="registrando" (click)="simularRegistro()">
    <mat-icon>science</mat-icon>
    Simular registro
  </button>
</div>

<app-lista-dados
  *ngIf="modoExibicao === 'historico'"
  [upTitulo]="'Histórico de Registros'"
  [upIcone]="'history'"
  [upCor]="'2E7D32'"
  [upDados]="logsHistorico"
  [upColunas]="colunasListaDados"
  [upCarregando]="!!subscription || registrando"
  [upHabilitaBotaoIncluir]="false"
  [upHabilitaBotaoEditar]="false"
  [upHabilitaBotaoExcluir]="true"
  [upHabilitaContador]="true"
  [upHabilitaFiltroRapido]="false"
  [upHabilitaPaginacao]="true"
  [upTotalRegistros]="totalLogsHistorico"
  [upPaginaAtual]="paginaHistorico"
  [upItensPorPagina]="itensPorPaginaHistorico"
  [upOpcoesItensPorPagina]="[10, 25, 50, 100]"
  [upLargura]="2"
  (ueBotaoExcluir)="onDelete($event)"
  (ueMudouPagina)="onMudouPaginaHistorico($event)">
</app-lista-dados>

<app-ponto-eletronico-agendamentos *ngIf="modoExibicao === 'agendamentos'"></app-ponto-eletronico-agendamentos>

<app-ponto-eletronico-calendario
  *ngIf="modoExibicao === 'calendario'"
  [logs]="logs">
</app-ponto-eletronico-calendario>

<app-ponto-eletronico-feriados *ngIf="modoExibicao === 'feriados'"></app-ponto-eletronico-feriados>
